import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { includes } from 'lodash';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject, Subscription } from 'rxjs';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { ConfirmationModelComponent } from 'src/app/shared/components/confirmation-model/confirmation-model.component';
import { DefaultLanguageId, imageAllowedExtension, Modalconfig, serverUrl } from 'src/app/shared/constants';
import { Asset, ContentBlock, VideoBlock } from 'src/app/shared/model/container.models';
import { CommonHttpService } from 'src/app/shared/services/common-http/common-http.service';

@Component({
    selector: 'app-edit-video',
    templateUrl: './edit-video.component.html',
    styleUrls: ['./edit-video.component.scss'],
    standalone: false
})
export class EditVideoComponent {

  contentBlock: ContentBlock;
  vidBlock: VideoBlock;
  showProgress = {
    mp4: null,
    image: null
  };
  uploadedResource = {
    mp4: null,
    webm: null,
    image: null
  };
  progressPercent = {
    mp4: 0,
    image: 0
  };
  isProgressing = {
    mp4: 0,
    image: 0
  };

  selectedFile: any;
  thumbNailStyle;
  secondaryUrl: string = null;
  serverUrl = serverUrl;
  videoProcessing: string;
  devicePixelRatio = devicePixelRatio;
  defaultLanguageId = DefaultLanguageId;
  languageId: number;
  apiUrl = '/api/Assets/UploadVideoFileAsChunk';
  isEmbedThirdPartyUrl = false;
  primaryUrl: string = null;
  confModalRef: BsModalRef;
  confModalSubsciber: Subscription;
  onclose = new Subject();
  constructor(
    public san: DomSanitizer,
    private commonHttpService: CommonHttpService,
    private modalService: BsModalService,
    private authService: AuthService
  ) { }


  /**
 * To set url for video component based on type of video
 */
  setVideoUrls() {
    if (this.contentBlock.videoBlock != null) {
      switch (this.contentBlock.videoBlock.videoType) {
        case 1:
          this.primaryUrl = 'https://player.vimeo.com/video/' + this.contentBlock.videoBlock.url.match(/([0-9])/g).join('');
          break;
        case 2:
          this.getYouTubeUrl(this.contentBlock.videoBlock.url);
          break;
        default:
          const placeHolderImageId = this.contentBlock.videoBlock.placeHolderImageId;
          if (this.contentBlock.videoBlock.url) {
            this.primaryUrl = this.contentBlock.videoBlock.url;
          }
          if (placeHolderImageId) {
            const token = this.authService.token();
            this.thumbNailStyle = {
              'background-image': `url(${serverUrl}/api/Assets/GetPlaybookTilesImage/${placeHolderImageId}?width=1024&ratio=${this.devicePixelRatio}&access_token=${token})`,
              width: '100%',
            };
          } else {
            this.thumbNailStyle = {
              'background-image': 'none',
              width: '100%',
            };
          }
          break;
      }
    }
  }

  /**
   * To get youtube ember url based on url in menifest
   */
  getYouTubeUrl(url) {
    const vid = url.match(/((=|\/){1})(\w|\d|-)*$/g);
    this.primaryUrl = url;
    if (vid != null && vid.length > 0) {
      this.primaryUrl = 'https://youtube.com/embed/' + url.match(/((=|\/){1})(\w|\d|-)*$/g).join('').replace('=', '').replace('/', '') + '?rel=0';
    }
  }



  /**
   * Method to handle validation of file format before uploading
   * @param event FileUploader event containing Content to be uploaded
   * @param fileType FileType to handle content accordingly
   */
  fileSelected(event, fileType) {
    this.selectedFile = event.target.files[0] as File;
    switch (fileType) {
      case 1:
        if (this.selectedFile.type.match('video/mp4')) {
          this.uploadResource(this.selectedFile, 1);
        } else {
          const initialState = {
            msg: 'This is not a valid extension. Supported extensions is : mp4',
            showCancelBtn: false
          };
          this.confModalRef = this.modalService.show(ConfirmationModelComponent,
            Object.assign({ initialState }, { class: 'custom-modal' }, Modalconfig));
          this.confModalSubsciber = this.confModalRef.content.onclose.subscribe((res) => {
            this.confModalRef.hide();
            this.confModalSubsciber.unsubscribe();
          });
        }
        break;
      case 3:
        const isValidExtension = this.validateExtension();
        if (isValidExtension) {
          this.uploadResource(this.selectedFile, 3);
        } else {
          const initialState = {
            msg: 'This is not a valid extension. Supported extensions are : ' + imageAllowedExtension.join(',') + '.',
            showCancelBtn: false
          };
          this.confModalRef = this.modalService.show(ConfirmationModelComponent,
            Object.assign({ initialState }, { class: 'custom-modal' }, Modalconfig));
          this.confModalSubsciber = this.confModalRef.content.onclose.subscribe((res) => {
            this.confModalRef.hide();
            this.confModalSubsciber.unsubscribe();
          });
        }
        break;
      default:
        break;
    }
  }

  validateExtension() {
    const extensionArray = this.selectedFile.name.split('.');
    const extension = extensionArray[extensionArray.length - 1].toLowerCase();
    const isValidExtension = includes(imageAllowedExtension, extension);
    return isValidExtension;
  }

  /**
   * Method to upload resource to server
   * @param selectedFile File data for uploading
   * @param fileType Filetype for setting response accordingly after uploading
   */
  uploadResource(selectedFile, fileType) {
    this.isProgressing.image = 1;
    const formData = new FormData() as any;
    formData.append('file', selectedFile);
    this.showProgress.image = true;
    this.commonHttpService.postWithProgress(
      {
        uri: fileType === 3 ? '/api/Assets/UploadImage' : '/api/Assets/UploadResource',
        object: formData
      }).subscribe((response: Asset | number) => {
        if (typeof response === 'number') {
          this.progressPercent.image = response;
        } else if (response) {
          this.showAsset(selectedFile, fileType, response);
        }
      }, (error) => {
        this.isProgressing.image = 0;
      });
  }

  showAsset(selectedFile, fileType, response, urlData?) {
    if (fileType === 1) {
      if (urlData) {
        this.uploadedResource.mp4 = urlData.saasUrl;
      }
      this.vidBlock.asset = response;
      this.vidBlock.assetId = response.id;
      this.showProgress.mp4 = false;
      this.progressPercent.mp4 = 0;
      this.isProgressing.mp4 = 0;
    } else {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(selectedFile);
      fileReader.onload = (e) => {
        this.uploadedResource.image = fileReader.result;
        this.vidBlock.placeHolderImageId = response.id;
        this.vidBlock.placeHolderImage = response;
        this.showProgress.image = false;
        this.progressPercent.image = 0;
        this.isProgressing.image = 0;
      }
    }
  }

  progressPercentage(progress) {
    this.showProgress.mp4 = true;
    this.isProgressing.mp4 = 1;
    if (typeof progress.percentage === 'number') {
      this.progressPercent.mp4 = progress.percentage;
      this.videoProcessing = progress.text;
    } else {
      this.progressPercent.mp4 = 100;
      this.videoProcessing = progress.percentage;
    }
  }

  fileStatusUpdate(fileStatus) {
    if (fileStatus.status) {
      this.showAsset(fileStatus.file, 1, fileStatus.assetData, fileStatus.url);
    }
  }

  /**
   * To set srcs for preview for different contents
   * @param fileType File type for uploading different content type
   */
  getAssetSrc(fileType) {
    if (fileType === 1) {
      if (this.uploadedResource.mp4 != null) {
        return this.uploadedResource.mp4;
      } else if (this.vidBlock.assetId) {
        return '/api/Assets/GetResourceById/' + this.vidBlock.assetId;
      }
    } else {
      if (this.uploadedResource.image != null) {
        return this.uploadedResource.image;
      } else if (this.vidBlock.placeHolderImageId) {
        return '/api/Assets/Image/' + this.vidBlock.placeHolderImageId;
      }
    }
    return '';
  }

  /**
   * To remove perticular file on click of remove button by user
   * @param fileType File type for uploading different content type
   */
  removeAsset(fileType) {
    switch (fileType) {
      case 1:
        this.vidBlock.asset = null;
        this.vidBlock.assetId = null;
        break;
      case 3:
        this.vidBlock.placeHolderImageId = null;
        this.vidBlock.placeHolderImage = null;
        break;
      default:
        break;
    }
  }

  /**
   * To add or update videoBlock
   */
  updateVideoBlock() {
    let reqObj = {
      url: this.vidBlock.url,
      assetId: this.vidBlock.external ? null : this.vidBlock.assetId,
      caption: this.vidBlock.caption,
      external: this.vidBlock.external,
      placeHolderImageId: this.vidBlock.placeHolderImageId ? this.vidBlock.placeHolderImageId : null,
      videoTitle: this.vidBlock.videoTitle,
      talentName: this.vidBlock.talentName,
      description: this.vidBlock.description
    };
    this.closeEditVideoModal(reqObj)
  }

  /**
   * Method to open file dialog according to fileType
   * @param fileType File type for uploading different content type
   */
  openFileDialog(fileType) {
    if (fileType === 1) {
      $('#uploadMp4').trigger('click');
    } else {
      $('#uploadplaceholder').trigger('click');
    }
  }

  closeEditVideoModal(reqObj = null) {
    this.onclose.next(reqObj);
    setTimeout(() => {
      this.isProgressing.image = 0;
      this.isProgressing.mp4 = 0;
      this.progressPercent.mp4 = 0;
      this.progressPercent.image = 0;
      this.showProgress.image = false;
      this.showProgress.mp4 = false;
    }, 1000);
  }
  checkVideoUrl(videoUrl: string) {
    return !!videoUrl && !(videoUrl.includes('vimeo') || videoUrl.includes('youtu'));
  }
}
